import { useZakekeHelpers } from "@zakeke/zakeke-customizer-react";
import { ImageGalleryImage } from "../../../components/widgets/imagesGallery";

const useClipartsCreateImage = () => {
    const { getImage } = useZakekeHelpers();

    return async (galleryImage: ImageGalleryImage) => getImage(parseInt(galleryImage.id))
}

export default useClipartsCreateImage;